import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { CloseStrongIcon } from 'src/monet/icons';
import classNames from 'classnames';

const DialogTransition = ({ children, duration }) => (
  <Transition.Child
    as={Fragment}
    enter={`ease-out duration-${duration}`}
    enterFrom='opacity-0'
    enterTo='opacity-100'
    leave={`ease-in duration-${duration}`}
    leaveFrom='opacity-100'
    leaveTo='opacity-0'
  >
    {children}
  </Transition.Child>
);

const ANIMATION_DURATION_MS = 200;

export const FullscreenPreviewModal = ({ openRef, children, onClose }) => {
  const [opened, setOpened] = useState(false);
  const closeRef = useRef();

  const onDialogClose = () => {
    closeRef.current();
    onClose && onClose();
  };

  useEffect(() => {
    openRef.current = async () => {
      setOpened(true);
    };
    closeRef.current = async () => {
      setOpened(false);
    };
  }, [openRef]);

  return (
    <Transition show={opened} as={Fragment}>
      <Dialog open={opened} onClose={onDialogClose} className='fixed z-10 inset-0 overflow-y-auto'>
        <div className='flex items-center justify-center h-full w-full'>
          <DialogTransition duration={ANIMATION_DURATION_MS}>
            <Dialog.Overlay className='fixed inset-0 bg-bedrock-black' onClick={onDialogClose} />
          </DialogTransition>
          <DialogTransition duration={ANIMATION_DURATION_MS}>
            <div className={classNames('relative flex flex-col rounded w-full mx-auto h-full')}>
              <div className='flex w-full h-full overflow-y-auto'>{children}</div>
              <div className='flex absolute z-10 top-2 right-2'>
                <button
                  type='button'
                  className='flex items-center justify-center text-bedrock-white bg-bedrock-black/backdrop hover:opacity-80 rounded-full w-12 h-12'
                  onClick={onDialogClose}
                >
                  <CloseStrongIcon className='w-5 h-5' />
                </button>
              </div>
            </div>
          </DialogTransition>
        </div>
      </Dialog>
    </Transition>
  );
};
